import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

@Component({
  selector: 'app-account-disabled-dialog',
  template: `
    <h2 mat-dialog-title>Account Disabled</h2>
    <mat-dialog-content>
      <p>Your account has been disabled by an administrator.</p>
      <p>Please contact support for assistance.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button color="primary" (click)="close()">OK</button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content { margin-bottom: 16px; }
  `],
  standalone:true,
  imports:[CommonModule, MatDialogTitle, MatDialogContent, MatDialogActions, MatButton]
})
export class AccountDisabledDialogComponent {
  constructor(public dialogRef: MatDialogRef<AccountDisabledDialogComponent>) {}

  close() {
    this.dialogRef.close();
  }
}